define('components/asset-player/models/asset',[
    'components/boilerplate/models/base',
    'components/asset-player/collections/media-files'
], function (Base, MediaFiles) {
    "use strict";

    var Asset = Base.extend({
        "idAttribute": "guid",

        "complexRelations": function () {
            var lowerCase;

            lowerCase = function (string) {
                return string && string.toLowerCase() || string;
            };

            return [
                {
                    "attr": "createdBy",
                    "fn": lowerCase
                },
                {
                    "attr": "guid",
                    "fn": lowerCase
                },
                {
                    "attr": "mediaFiles",
                    "Class": MediaFiles
                },
                {
                    "attr": "seriesGuid",
                    "fn": lowerCase
                },
                {
                    "attr": "typeGuid",
                    "fn": lowerCase
                }
            ];
        },

        "defaults": function () {
            return {
                "guid": null,
                "typeGuid": null,
                "cached": false,
                "mediaFiles": null
            };
        },

        "isAudio": function () {
            return Asset.TypeGuids.AUDIO.indexOf(this.get('typeGuid')) > -1;
        },

        "isImage": function () {
            return Asset.TypeGuids.IMAGE.indexOf(this.get('typeGuid')) > -1;
        },

        "isInteractive": function () {
            return Asset.TypeGuids.INTERACTIVE.indexOf(this.get('typeGuid')) > -1;
        },

        "isPDF": function () {
            return Asset.TypeGuids.PDF.indexOf(this.get('typeGuid')) > -1;
        },

        "isTheme": function () {
            return Asset.TypeGuids.THEME.indexOf(this.get('typeGuid')) > -1;
        },

        "isVideo": function () {
            return Asset.TypeGuids.VIDEO.indexOf(this.get('typeGuid')) > -1;
        }
    }, {
        "TypeGuids": {
            "AUDIO": [
                '9c86af9f-5420-4662-abed-910857f7e301', // audio
                'bf9bfd69-0ebb-4092-a69c-6ba3893a0dd8', // song
                'c24a158a-3654-47db-8fe7-889859d02003'  // sound effect
            ],

            "IMAGE": [
                '3123b3ad-3c2d-49cf-92ce-9927c3c09e64', // image
                '1aa883f4-b310-4a5a-9d35-d07dc8cadf6c'  // non-searchable
            ],

            "INTERACTIVE": [
                '6c7a0f71-17d8-4578-8f5e-9c20a01b40a7' // Math Interactive
            ],

            "PDF": [
                'a000af07-7919-4735-b6f4-6f2636aae3b8' // Activity
            ],

            "THEME": [
                '9f25f18f-71f3-4e06-8e0b-598ee9b5da94' // Theme
            ],

            "VIDEO": [
                'b373b9c1-fe6d-4891-9ff3-3b59b23550e2', // title
                'b2ae1c36-4265-46d4-b8d0-f430d6e1357e', // titlechapter
                '13f26cf6-734e-40a7-8be0-b43cccc36d24'  // titlechaptersection
            ]
        }
    });

    return Asset;
});

